var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40002 6.7759L4.04647 6.42235L1.41588 3.79176C1.35956 3.73855 1.2848 3.70917 1.20724 3.70984C1.12859 3.71052 1.05334 3.74207 0.997719 3.7977C0.942097 3.85332 0.910546 3.92856 0.909862 4.00722C0.909188 4.08478 0.938577 4.15954 0.991786 4.21586L4.18792 7.41199C4.18794 7.41201 4.18796 7.41203 4.18797 7.41204C4.24423 7.46825 4.3205 7.49983 4.40002 7.49983C4.47954 7.49983 4.55581 7.46825 4.61207 7.41204L4.61212 7.41199M4.40002 6.7759L4.96562 7.7656L4.61212 7.41199M4.40002 6.7759L4.75357 6.42235L10.5879 0.588004L10.2344 0.234397L10.588 0.587951C10.6442 0.531742 10.7205 0.500168 10.8 0.500168C10.8795 0.500168 10.9558 0.531722 11.012 0.587897M4.40002 6.7759L11.0121 1.01204C11.0683 0.955791 11.0998 0.879522 11.0998 0.799997C11.0998 0.720446 11.0683 0.644154 11.012 0.587897M4.61212 7.41199L11.012 1.0121L4.61212 7.41199ZM11.012 0.587897C11.0121 0.587933 11.0121 0.587968 11.0121 0.588004L11.3656 0.234397L11.012 0.587897Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick2);
export default __webpack_public_path__ + "static/media/tick2.09bcfc67dc514d7838be2e7a76fdc3c0.svg";
export { ForwardRef as ReactComponent };